import { useState, useEffect, useRef } from 'react';

export const useDetailConfigLocal = (detailConfig, item) => {
    const [detailConfigLocal, setDetailConfigLocal] = useState(detailConfig);
    const prevItemDataRef = useRef();

    useEffect(() => {
        if (!item?.data || !detailConfig) return;

        // Controlla se i dati sono realmente cambiati
        const currentItemData = JSON.stringify(item.data);
        if (currentItemData === prevItemDataRef.current) return;
        prevItemDataRef.current = currentItemData;

        const newDetailConfigLocal = { ...detailConfig };
        const matchingVehiclesInputElement = newDetailConfigLocal.tabs[0].fieldsets[0].fields.matchingVehicles.relation;

        let _related_partner_name_field;
        switch(item.data?.revenueDeal?.partner.supplier_type) {
            case "oem":
                _related_partner_name_field = '_related_oem_name';
                break;
            case "dealer":
                _related_partner_name_field = '_related_dealer_name';
                break;
            case "renter":
            default:
                _related_partner_name_field = '_related_renter_name';
                break;
        }
        matchingVehiclesInputElement.filter = {
            items: [
                ...(item.data?.revenueRules ?? item.data?.commissionRules ?? []).map((rule) => ({
                    field: rule.field,
                    operator: rule.operator,
                    value: rule.value
                })),
                {
                    field: _related_partner_name_field,
                    operator: "equals",
                    value: item.data?.revenueDeal?.partner?.name ?? item.data?.commissionDeal?.partner?.name ?? null
                }
            ]
        };

        const start_at = new Date(item.data?.revenueDeal?.start_at ?? item.data?.commissionDeal?.start_at ?? null);
        const start_at_formatted = start_at && start_at.toLocaleDateString('en-CA', { timeZone: 'Europe/Rome', year: 'numeric', month: '2-digit', day: '2-digit' });

        const end_at = new Date(item.data?.revenueDeal?.end_at ?? item.data?.commissionDeal?.end_at ?? null);
        const end_at_formatted = end_at && end_at.toLocaleDateString('en-CA', { timeZone: 'Europe/Rome', year: 'numeric', month: '2-digit', day: '2-digit' });

        if (start_at_formatted && end_at_formatted) {
            matchingVehiclesInputElement.filter.items.push(
                {
                    field: '_related_contract_contract_at',
                    operator: "between",
                    value: {
                        from: start_at_formatted,
                        to: end_at_formatted ?? null
                    }
                }
            );
        }

        matchingVehiclesInputElement.columnsNeeded = [
            "_related_renter_name",
            "_related_dealer_name",
            "_related_oem_name",
            "_related_contract_contract_at",
            "_related_contract_orderPurchaseType",
            "_related_contract_orderType",
            "_related_contract_orderExtensionType",
            "plate",
            "status",
            "_related_legalEntity_name",
            "_related_legalEntity_commercialCluster",
            "_related_setup_make",
            "_related_setup_model",
            "_related_setup_setup",
            "_related_contract_contractDuration",
            "_related_contract_contractMileage"
        ]

        console.info('Detail di PartnershipRuleset imposto i filtri alla lista veicoli', matchingVehiclesInputElement, item);
        setDetailConfigLocal(newDetailConfigLocal);
    }, [detailConfig, item?.data]);

    return { detailConfigLocal };
};